import { z } from 'zod';

export const formSchema = z.object({
  nombre: z.string().min(3, 'El nombre debe tener al menos 3 caracteres',),
  texto_uno: z.string().min(1, 'El texto 1 es obligatorio'),
  texto_dos: z.string().min(1, 'El texto 2 es obligatorio'),
  imagen: z.string().min(1, 'La imagen es obligatoria'),
  esDetalle: z.boolean(),
  detalle: z.string().optional(),
  /* sucursales: z.array(z.object({
    label: z.string()
  })).nonempty('Debes tener al menos una sucursal'), */
}).superRefine((data, ctx) => {
  console.log("data",data);
  if (data.esDetalle && (!data.detalle || data.detalle.trim() === '')) {
    ctx.addIssue({
      path: ['detalle'],
      code: z.ZodIssueCode.custom,
      message: 'El detalle es obligatorio',
    });
  }
});